export default __webpack_public_path__ + "1313e4a042894c5f20af4d5e332c8344.svg";